//=============================================================================
// Contents   : HRDB
//              ユーザーマスタ
//              GetUserList
// Author     : RV奥村
// LastUpdate : 2023/04/12
// Since      : 2023/04/12
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useProvideData } from "03CommonApiParts/use-context";
/* ====== CSS ====== */
/* ====== Image ====== */
/* ====== Component Js/Jsx ====== */
/* ====== Style ====== */
import { CODEDIFINITION_STORAGE, screenMaster, USERINFO_STORAGE,AUTH_TOKEN } from "03CommonApiParts/CodeDefinition";
import { CFArrayFount, CFCheckArrayData, CFCreateApplyList, CFJsonIgnore, CFStringDecodeJP, CFStringEncodeJP, checkChangeFlag, confirmChange } from "03CommonApiParts/CommonFunction";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { Table } from "02CommonUiParts/TableParts/Table";
import { useFieldArray, useForm } from "react-hook-form";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { Title } from "01Pages/Common/UiParts/Title";
import { TableArray } from "02CommonUiParts/TableParts/TableArray";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";
import { ButtonIconCopyRegister } from "02CommonUiParts/ButtonParts/ButtonBase";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
const CommonStyle = StyleCommon();//共通スタイルドコンポーネント
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ




/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= ユーザーマスタ ========= */
export const GetUserList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const apiData = useProvideData();//APIデータ取得
    const location = useLocation();

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    const locationState = location.state;
    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* CODEDIFINITION_STORAGEからコード定義を取得 */
	const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);//sessionStorageからコードマスタを取得
	var codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    // const screenIdList = CFArrayFount(codeDefinitionValue,'code','screenId').list; //画面IDのリストを取得
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id
    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 


    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    const [progress, setProgress] = useState(false); //プログレスバー表示用
     const [dataRow, setDataRow] = useState({
        applyList:[],
        aplySrtDate:'',
        list:[]
    });
    const [confirm, setConfirm] = useState({});//確認用データ格納用
    const [newData, setNewData] = useState([]);//変更後データ格納用
    const [departmentMaster,setDepartmentMaster] = useState([]);
    const [pageMode, setPageMode] = useState('list');
    const [empList,setEmpList] = useState([]);
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    });
    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    const { register, getValues,setValue, handleSubmit,watch,clearErrors,control,formState: { errors },trigger } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange',
        shouldUseNativeValidation: false,
        shouldUnregister: false,
    });
    const { fields, append, remove } = useFieldArray(
		{
			control,
			name: `payload.list`
		}
	);
    

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        /* APIデータ取得 */
        getMaster();
        // eslint-disable-next-line
    },[]);
    /* 従業員検索処理　*/
    const getEmployeeData = async(id) =>{
        const data = getValues(id);
        setEmpList([]);
        if(!data) return;
        /* プログレスバー表示 */
        setProgress(true);
        const apiPath = '/search/getemployee';	//API Path

		/* リクエスト*/
		const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
		/* キー */
		key.aplySrtDate = getValues('payload')? getValues('payload').aplySrtDate : null ;
		key.sarValue = CFStringEncodeJP(data,base64Swicth);

		/* リクエストパラメータ */
		const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
		await apiData.getDataPost(apiPath, apiBody, (result) => {
			/* プログレスバー非表示 */
			setProgress(false);
			if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const list = [];
                data.forEach((item)=>{
                    list.push({
                        empNmb			:item.empNmb,		//従業員番号	       
                        empFrgnFullName	:item.empFrgnFullName ? CFStringDecodeJP(item.empFrgnFullName,base64Swicth) : '',//従業員フリガナ氏名
                        empFullName		:item.empFullName ? CFStringDecodeJP(item.empFullName,base64Swicth) : '',	     //従業員氏名	       
                        mailAdrs		:item.mailAdrs,	    //メールアドレス	   
                        dptCd			:item.dptCd,        //部署コード	       
                        dptName			:item.dptName ? CFStringDecodeJP(item.dptName,base64Swicth) : '',		//部署名	           
                        dptAbrName		:item.dptAbrName ? CFStringDecodeJP(item.dptAbrName,base64Swicth) : '',	//部署略名	       
                    })
                });
                setEmpList(list);
			}else{//APIリクエスト結果 = 異常
                setValue('payload.list', []);
			    /* スナックバー表示 */
			    setSnackbarMessage({      
			        ...snackbarMessage,
			        open:true,
			        message:result,//APIによるエラー
			        $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
			        type: 1,//APIエラー時:1,それ以外:2 
			        level:'error',//エラースナックバー
			    })
			}
		});
    };
	/* ====== マスタの取得処理 ====== */
    const getMaster = async(date) => {
        /* リクエスト先 */
        const apiPath = '/search/getmaster';
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* キー */
        key.aplySrtDate = date ? date : null;
        key.mstList = ['departmentMaster'];//部署マスタ

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const masterList = [];
                data.forEach((master)=>{
                    const list = [];
                    master.list.forEach((item)=>{
                        list.push({
                            value:item.value,
                            label:CFStringDecodeJP(item.label,base64Swicth)
                        })
                    })
                    masterList.push({
                        code:master.code,
                        name:CFStringDecodeJP(master.name,base64Swicth),
                        list:list
                    })
                });
                setDepartmentMaster(CFArrayFount(masterList,'code','departmentMaster'));
                /* データ取得 */
                date ? getData(date) : getData();

            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };
   
    const getData = async(date) =>{
        /* プログレスバー表示 */
        setProgress(true);
        const apiPath = '/master/getlistuserauthority';	//API Path

		/* リクエスト*/
		const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
        
		/* キー */
		key.authGpCd = locationState.authGpCd;
		key.aplySrtDate = date ? date : null;

		/* リクエストパラメータ */
		const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
		await apiData.getDataPost(apiPath, apiBody, (result) => {
			/* プログレスバー非表示 */
			setProgress(false);
			if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                    /* 適用開始日リストの作成　*/
                    const createApplyList = CFCreateApplyList(data.aplySrtDateList,'aplySrtDate');
                    let aplySrtDate;
                    /* 割当対象情報 */
                    const editData = [];
                    data.asiTrgInfo.forEach((asiTrgInfoItem)=>{
                       /* 適用開始日 */
                        aplySrtDate = asiTrgInfoItem.aplySrtDate;
                        asiTrgInfoItem.asiTrgList.forEach((asiTrgListItem,index)=>{
                            const dataObject = {};
                            /* 割当対象リスト */
                            dataObject.asiTrgDsnCd  =   asiTrgListItem.asiTrgDsnCd;    //割当対象種別コード						
                            asiTrgListItem.empNmb   && (dataObject.empNmb = asiTrgListItem.empNmb + ' ' + CFStringDecodeJP(asiTrgListItem.empFullName,base64Swicth) + ' ' + asiTrgListItem.mailAdrs);					
                            asiTrgListItem.dptCd    && (dataObject.dptCd  = asiTrgListItem.dptCd + ' ' + CFStringDecodeJP(asiTrgListItem.dptName,base64Swicth));      //部署コード						
                            dataObject.aplyEndDate  = asiTrgListItem.aplyEndDate;      //適用終了日	
                            dataObject.id = index
                            
                            editData.push(dataObject);
                        });
                    });
                    const payload = {
                        applyList:createApplyList.applyList,
                        aplySrtDate:aplySrtDate,
                        list:editData,
                    };
                    setDataRow(payload);
                    setValue('payload.aplySrtDate',aplySrtDate);
                    setValue('payload.list', payload.list);
                  
                
                /* 件数0件 */
                if(result.responseData.data.metadata[0].count === 0){ 
                    /* 適用開始日リストがある場合 */
                    if(createApplyList.applyList.length === 0){
                        setPageMode('addList'); 
                    }
                    /* 適用開始日リストがない場合 */
                    else{
                        setPageMode('pastList') 
                    }
                } 
                /* 一番最新の適用日かつ現在適用中でなければ削除ボタンとコピーして登録ボタン表示を表示　*/
                /* 一番最新の適用日と現在表示している適用開始日が同一 */
                else if(createApplyList.futureList[0] === aplySrtDate){
                     /* 現在適用されている適用開始日と一番最新の適用開始日 */
                     if(CFArrayFount(createApplyList.applyList,'aplyFlag',true).value === createApplyList.futureList[0]){
                         setPageMode('futureList'); 
                     }else{
                         setPageMode('futureDeleteList');
                     }
                }else if(createApplyList.pastList.some(day => day === aplySrtDate)){
                     setPageMode('pastList') 
                }else{
                     setPageMode('list');
                };
                
			}else{//APIリクエスト結果 = 異常
                setValue('payload.list', []);
                setPageMode('pastList')
			    /* スナックバー表示 */
			    setSnackbarMessage({      
			        ...snackbarMessage,
			        open:true,
			        message:result,//APIによるエラー
			        type: 1,//APIエラー時:1,それ以外:2 
			        level:'error',//エラースナックバー
			    })
			}
            /* 画面表示開始 */
            setLoading(true);
		});

    };
    /* ===== 更新処理　===== */
    const updateData = async() =>{
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiPath = '/master/updateuserauthority';	//API Path
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};
        const payload = [];
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'UPDATE';

        /* キー */
        if(pageMode === 'registerConfirm'){
            key.aplySrtDate	= confirm.aplySrtDate;		            //適用開始日				
            key.authGpCd	= locationState.authGpCd;               //権限グループコード
        }else{
            key.aplySrtDate	= getValues('payload.aplySrtDate');		//適用開始日				
            key.authGpCd	= locationState.authGpCd;               //権限グループコード
        }

        newData.forEach((row)=>{
            if(Object.keys(row).length === 0){

            }else if(row.asiTrgDsnCd === 'employee'){
                payload.push({
                    asiTrgDsnCd:row.asiTrgDsnCd, //割当対象種別コード
                    empNmb:row.empNmb.split(' ')[0], //従業員番号
                    dptCd:row.dptCd.split(' ')[0],//部署コード
                    aplyEndDate:row.aplyEndDate, //適用終了日
                });
            }else{
                payload.push({
                    asiTrgDsnCd:row.asiTrgDsnCd, //割当対象種別コード
                    empNmb:null,                //従業員番号
                    dptCd:row.dptCd.split(' ')[0],//部署コード
                    aplyEndDate:row.aplyEndDate, //適用終了日
                });
            }
            
            
        });
        /* リクエストパラメータ */
        const apiBody = { handlingInformation:handlingInformation, key:key, payload:payload };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                getAuthToken();
                /* プログレスバー非表示 */
				setProgress(false);
                navigate('/common/completion', {
                    state:{
                        title: 'ユーザーマスタメンテ編集完了', 
                        message: screenDisplayMessage('CMNI004'), //データの更新が完了しました。
                        button:[
                            {name: '一覧画面へ戻る', path:'/master/user/list',state:{authGpCd:locationState.authGpCd,authGpName:locationState?.authGpName}},
                        ]
                    },
                    replace:true
                },);
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            };
        });
    };
    
    /* ===== 削除処理　===== */
    const deleteData = async() =>{
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiPath = '/master/deleteuserauthority';	//API Path
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'DELETE';

        /* キー */
        key.authGpCd = locationState.authGpCd;
        key.aplySrtDate = getValues('payload.aplySrtDate');

        /* リクエストパラメータ */
        const apiBody = { handlingInformation:handlingInformation, key:key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                getAuthToken();
                navigate('/common/completion', {
                    state:{
                        title: 'ユーザーマスタマスタメンテ削除完了', 
                        message: screenDisplayMessage('CMNI005'), //データの削除完了
                        button:[
                            {name: '一覧画面へ戻る', path:'/master/user/list',state:{authGpCd:locationState.authGpCd,authGpName:locationState?.authGpName}},
                        ]
                    },
                    replace:true
                });
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            };
        });
    };

    /* ===== 認可情報取得　===== */
    const getAuthToken = async() =>{
        // console.log('権限更新')
        /* 処理が何度も走らないように制御 */
        if(progress) return;
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト */
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
        /* キー */
        key.mailAdrs = userInfoValue.mail; 

        /* リクエスト先 */
        const apiPath = '/authorization/getauthorizationtoken';	//API Path
        
        /* リクエストパラメータ */
        const apiBody = { handlingInformation: handlingInformation, key: key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            if(result.isSuccessed) {
                const data = JSON.parse(result.responseData.data).encryptedToken;
                sessionStorage.setItem(AUTH_TOKEN,JSON.stringify(data));
            }else{//APIリクエスト結果 = 異常
                /* プログレスバー非表示 */
                setProgress(false);
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
                
            };
        });
    };

    /* === キャンセル・戻るボタンを押した時の処理=== */
    const onClickLeft = () => {
        if(pageMode === 'list' ||pageMode === 'pastList' ||pageMode === 'addList' ||pageMode === 'futureList'){
            navigate('/master/authority/list');
        }else if(pageMode === 'edit' || pageMode === 'register'){
            /* 変更前データ */
            const oldData = [];
            /* 変更後データ */
            const newData = [];
            
            const afterCancel = () =>{
                getMaster();
            }
            const key = ['asiTrgDsnCd','empNmb','dptCd','aplyEndDate','id'];
            /* 配列データの変更を確認して調整する処理 */
            CFCheckArrayData(dataRow.list,getValues('payload.list'),oldData,newData,key)
            if(CFJsonIgnore(oldData) === CFJsonIgnore(newData)){
                afterCancel();
            }else{
                /* 更新確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open: true,
                    message: 'CMNC001',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterCancel,
                    pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }
        }else{
            setValue('payload.list',newData);
            pageMode === 'registerConfirm' ? setPageMode('register') : setPageMode('edit');
        }
    };

    /* データ確認処理 */
    const checkEditData = (data) =>{
        const key = ['asiTrgDsnCd','empNmb','dptCd','aplyEndDate','id'];
        /* 変更前データ */
        const oldData = [];
        /* 変更後データ */
        const newData = [];
        /* 配列データの変更を確認して調整する処理 */
        CFCheckArrayData(dataRow.list,data.payload.list,oldData,newData,key)

        /* 変更点がない場合　*/
        if(CFJsonIgnore(oldData) === CFJsonIgnore(newData)){
            /* スナックバー表示 */
            setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW004',
                type: 2,//APIエラー時:1,それ以外:2
            });
        }else{

        /* 変更点がある場合　*/
            /* 変更があればchangeFlagをtrueにする */
            let changeFlags = checkChangeFlag(oldData,newData, key);
            let changeData = confirmChange(changeFlags,oldData,newData, key);
            /* 確認用データの格納 */
            setConfirm(
                {
                    flags:changeFlags,
                    data:changeData,
                    aplySrtDate:getValues('payload.aplySrtDate')
                }
            );
            /* 変更後データの格納 */
            setNewData(data.payload.list);
            /* dataRowにセット */
            setValue('payload.list',dataRow.list);
            /* 確認モードに変更　*/
            pageMode === 'edit' ? setPageMode('updateConfirm') : setPageMode('registerConfirm');
        };
    }
    /* === 編集ボタンを押した時の処理=== */
    const onClickSubmit = (data) =>{
        if(pageMode === 'register'){
            const oldAplyDate = new Date(dataRow.aplySrtDate);
            const newAplyDate = new Date(data.payload.aplySrtDate);
            var today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            /* 登録しようとした適用日が今日よりも前 */
            if(today > newAplyDate){
               /* スナックバー表示 */
               setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW001',
                type: 2,//APIエラー時:1,それ以外:2 
                level:'error'//エラースナックバー
                })
            }
            else if(dataRow?.applyList?.some(e=>new Date(e.value).getTime() === newAplyDate.getTime())){
                /* スナックバー表示 */
                setSnackbarMessage({      
                 ...snackbarMessage,
                 open:true,
                 message:'CMNW006',
                 type: 2,//APIエラー時:1,それ以外:2 
                 level:'error'//エラースナックバー
                 })
             }
            /* 登録しようとした適用日がコピーしたデータよりも前 */
            else if( oldAplyDate > newAplyDate ){
                /* コピーしたデータが削除されても良いかを確認　*/
                const afterFunc = () =>{
                    /* データ確認処理　*/
                    checkEditData(data);
                }
                /* 確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open:true, 
                    message:'CMNC003',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterFunc,
                    pattern: 2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }else{
                /* データ確認処理　*/
                checkEditData(data);
            };
        }else{
            /* データ確認処理　*/
            checkEditData(data);
        }

    };

    
    /* === 編集・完了ボタンを押した時の処理=== */
    const onClickCenter = () =>{
        if(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'futureDeleteList'|| pageMode === 'addList'){
            setPageMode('edit');
        }else if(pageMode === 'updateConfirm'){
            updateData();
        }else if(pageMode === 'deleteConfirm'){
            deleteData();
        }else if(pageMode === 'registerConfirm'){
            updateData();
        };
    };

    /* ====== 削除ボタンを押した時の処理 ====== */
    const onClickRight = () =>{
        /* 変更後のデータをnewDataに入れておく */
		setNewData(getValues('payload.list'));
        /* deleteモードに変更 */
		setPageMode('deleteConfirm');
        /* dataRowにリセット */
        setValue('payload.list',dataRow.list);
    }
    /* ====== 適用日ボタン押下 ====== */
    const onChangeApply = (event) => {
        getMaster(event.target.value);
    };

    /* ====== コピーして登録ボタンを押下 ====== */
    const onClickCopyRegist = () =>{
        /* ====== 適用日登録時日付取得 ====== */
        var date = new Date();//今日の日付を取得
        const aplySrtDate = new Date(getValues('payload.aplySrtDate'))//今日の日付を取得
        if(aplySrtDate === date){
            date.setDate(date.getDate() + 1);
        }else if(aplySrtDate > date){
            date.setDate(aplySrtDate.getDate() + 1);
        };
        /* yyyy-mm-ddの形に変える */
        let year = date.getFullYear();//年を取得
        let month = ('00' + (date.getMonth()+1)).slice(-2)//月を取得
        let day = ('00' + (date.getDate())).slice(-2);//日を取得
        let today = year + '-' + month + '-' + day//それぞれをフォーマットになるよう結合する

        /*　日付のセット */
        setValue('payload.aplySrtDate',today);

        /* pageModeのセット */
        setPageMode('register');
    }

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    
    /* ====== 適用日データ ====== */
	const applyDateTableConfig = [
        {
			id:'row1', 
			label:'適用開始日', 
			list:[
				{
					name:'aplySrtDate',
					type:'applySelect',
					applyList: 'applyList',
					clickType: 'base',
				}
			]
        }
    ];

    /* ====== 適用日データ ====== */
	const applyDateTableCnfConfig = [
        {
            id:'row1', 
            label:'適用開始日', 
            list:[
                {name:'aplySrtDate', type:'dateLabel'}
            ]
        }
    ];

    /* ====== 適用日データ ====== */
	const applyDateTableRegConfig = [
        {
            id:'row1', 
            label:'適用開始日', 
            list:[
                {name:'aplySrtDate',type:'date',pattern:'date'},
            ]
        }
    ];

    const checkUnderbarType = (pageMode) =>{
        let result;
        switch(pageMode){
            case 'list':
                result = 'backEdit';
            break;
            case 'pastList':
                result = 'back';
            break;
            case 'addList':
                result = 'back';
            break;
            case 'futureList':
                result = 'backEdit';
            break;
            case 'futureDeleteList':
                result = 'backEditDelete';
            break;
            case 'edit':
                result = 'confirmCancel';
            break;
            case 'register':
                result = 'confirmCancel';
            break;
            case 'updateConfirm':
                result = 'completeBack';
            break;
            case 'deleteConfirm':
                result = 'completeBack';
            break;
            case 'registerConfirm':
                result = 'completeBack';
            break;
            // case 'list':
            
            // break;
            // case 'list':
            
            // break;
            default:
                result = 'edit';
            break;
        }
       return result;
    };

    /* ======== テーブルの設定 ======== */
    /* ====== テーブルヘッダーを定義 ====== */
    // id       : 項目名
    // id2       : 項目名2
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true
    const head = [
        { id: 'asiTrgDsnCd',    align: 'left',  width: '90px',  label1: '種別'},
        { id: 'empNmb',         align: 'left',    width: '520px', label1:'従業員'},
        { id: 'dptCd',          align: 'left',    width: '350px', label1:'部署'},
        { id: 'aplyEndDate',    align: 'left',    width: '120px', label1:'適用終了日'}
    ];
    const head2 = [
        { id: 'deleteIcon',     align: 'center', width: '50px',label1: '削除'},
        { id: 'asiTrgDsnCd',    align: 'left',  width: '100px',  label1: '種別',required:true},
        { id: 'empNmb',         align: 'left',    width: '520px', label1:'従業員'},
        { id: 'dptCd',          align: 'left',    width: '500px', label1:'部署'},
        { id: 'aplyEndDate',    align: 'left',    width: '120px', label1:'適用終了日',required:true}
    ];
    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton

    /* ====== テーブルデータを定義 ====== */
    const body = [
        { name: 'asiTrgDsnCd', type: 'edit',  align: 'left', master:CFArrayFount(codeDefinitionValue,'code','assignementTargetKindCode')},
        { name: 'empNmb',      type: 'label',  align: 'left'},
        { name: 'dptCd',       type: 'label',  align: 'left'},
        { name: 'aplyEndDate', type: 'dateLabel',   align: 'left'}
    ];
    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバー */}
            <LoadingProgressBar open={progress}/>
            {/* 画面タイトル */}
            <CommonStyle.GdivTitleWrapper>
            {/* <Title text={registerMode ? `${pageTitle}適用日登録` : editMode ? `${pageTitle}編集` : pageTitle} borderBottom='none' exp='説明が表示されます'/> */}
            <Title text={'ユーザーマスタ' + (pageMode.includes('Confirm') ? '確認' : pageMode === 'edit' ? '編集' : 'メンテ')} borderBottom='none'/>
            </CommonStyle.GdivTitleWrapper>
            {/* 確認文言 */}
            <CommonStyle.GdivConfirmText mode={pageMode}/>
            <CommonStyle.GdivPageContentsWrapper>
                <CommonStyle.GdivSubTitleWrapper>
                    <label style={{marginRight: '10px'}}>適用開始日情報</label>
                    {/* 一覧表示モードの時だけ表示 */}
                    {/* {console.log(pageMode)} */}
                    { pageMode === 'futureList'  || pageMode === 'futureDeleteList' ?
                    <ButtonIconCopyRegister onClick = {()=> onClickCopyRegist()}/> : ''}
                    { pageMode === 'addList' && 
                    <ButtonIconCopyRegister onClick={()=>onClickCopyRegist()}/>
                    }
                </CommonStyle.GdivSubTitleWrapper>
                <LeftTitleTable
                    className='baseText'
                    register={register}
                    payload='payload'
                    errors={errors}
                    dataRow={pageMode === 'registerConfirm' ? confirm : dataRow}
                    tableConfig={(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'pastList' || pageMode === 'futureDeleteList') ? applyDateTableConfig : ( pageMode === 'register' ? applyDateTableRegConfig : applyDateTableCnfConfig ) }
                    onChangeApply={onChangeApply}
                />
                <CommonStyle.GdivSubTitleWrapper style={{marginBottom:'8px', marginTop: '10px'}}>
                    {/* {subPageTitle} */}
                    {`権限グループ ${locationState?.authGpName}`}
                </CommonStyle.GdivSubTitleWrapper>   
                <form onSubmit={handleSubmit(onClickSubmit)}>
                    {pageMode === 'updateConfirm' || pageMode === 'registerConfirm' ?
                        <Table
                        headCells={head} //ヘッダの設定情報
                        bodyCells={body} //ボディの設定情報
                        payload='payload'
                        register={register}
                        errors={errors}
                        dataRow={confirm.data} //表示データ
                        notShowSearchNumber={true}
                        payloadCategory={'list'}
                        changeFlags={confirm?.flags}
                        /> 
                        :
                        <TableArray
                            paperStyle={{ maxHeight: 'calc(100vh - 320px)' }}
                            headCells={(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'pastList' || pageMode === 'futureDeleteList')?  head : head2} //ヘッダの設定情報
                            bodyCells={(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'pastList' || pageMode === 'futureDeleteList')? body :  
                            [
                                { name: 'deleteIcon',  type: 'deleteIcon',  align: 'center'},
                                { name: 'asiTrgDsnCd', type: 'select',      align: 'left', required:true, defaultValue:'employee', changeFunc: (index, event) => {
                                    if(event === 'department'){
                                        setValue(`payload.list.${index}.empNmb`, '');
                                        clearErrors(`payload.list.${index}.empNmb`);
                                    }
                                    ; 
                                    return;
                                },master:CFArrayFount(codeDefinitionValue,'code','assignementTargetKindCode')},
                                { name: 'empNmb',      type: 'inputVariableList',   align: 'left',  master:empList , onClickButton:getEmployeeData, checkItem:'asiTrgDsnCd', checkValue:'employee'},
                                { name: 'dptCd',       type: 'inputList',   align: 'left',          master:departmentMaster, checkItem:'asiTrgDsnCd', checkValue:'department', maxLength:136,required:true},
                                { name: 'aplyEndDate', type: 'date',        align: 'left',required:true,defaultValue:'9999-12-31'}
                            ]} //ボディの設定情報 
                            dataRow={dataRow.list} //表示データ
                            payloadData={watch('payload').list}
                            errors={errors}
                            payload='payload'
                            register={register}
                            fieldsList={fields}
                            append={append}
                            remove={remove}
                            hoverEffect={true}
                            payloadCategory='list'
                            showBottom={true}
                            notShowSearchNumber={pageMode === 'edit' || pageMode === 'register'}
                            changeOrder={true}
                            setValue={setValue}
                            getValues={getValues}
                            editMode={pageMode === 'edit' || pageMode === 'register'}
                            changeFlags={confirm.flags}
                            trigger={trigger}
                        />   
                    }
                    {/* アンダーバー */}
                    <Underbar
                        type={checkUnderbarType(pageMode)}//react-hook-form
                        onClickLeft={onClickLeft}//キャンセル・戻るボタン押下時の処理
                        onClickCenter={onClickCenter}//更新ボタン押下時の処理
                        onClickRight={onClickRight}//戻るボタン押下時の処理
                    />
                </form>
                
            </CommonStyle.GdivPageContentsWrapper>
            {/* ダイアログ */}
            <Dialog
				content={dialogMessage}
				set={setDialogMessage}
			/> 
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
                />
            
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 
